// extracted by mini-css-extract-plugin
module.exports = {"container":"VotableLayout_container__2HQ9A","headerColumn":"VotableLayout_headerColumn__2bPWn","vote":"VotableLayout_vote__W7t-C"};